const customFormater = (value) => {
    if (value === -1) {
        return ''
    } else {
        if (value === 0) {
            return 0
        }
        return value.toFixed(2)
    }
}

const options = {
    yaxis: {
        reversed: true
    },
    stroke: {
        show: true,
        width: 1,
        colors: ['#a8b3ae']
    },
    dataLabels: {
        enabled: true,
        formatter: (value) => customFormater(value),
        style: {
            colors: ['#6b6868']
        }
    },
    plotOptions: {
        noData: { text: 'Não há dados para os filtros selecionados' },
        heatmap: {
            enableShades: false,
            colorScale: {
                ranges: [
                    { // branco
                        from: -1,
                        to: -1,
                        name: 'Sem dados',
                        color: '#FFFFFF'
                    },
                    { // vermelho
                        from: 0,
                        to: 49.9,
                        name: '< 50%',
                        color: '#eed3d5'
                    },
                    { // amarelo
                        from: 50,
                        to: 79.9,
                        name: '50% - 79%',
                        color: '#f7f0c9'
                    },
                    { // verde
                        from: 80,
                        to: 100,
                        name: '80% - 100%',
                        color: '#c2e4d4'

                    }
                ]
            }
        }
    },
    parsing: {
        x: 'mesReferenciaFormatado',
        y: 'percentAlcancado'
    },
    tooltip: {
        enabled: false,
    },
    states: {
        hover: {
            filter: {
                type: 'none',
            },
        },
        active: {
            filter: {
                type: 'none',
            },
        },
    },
}

export default options;